import type { ReactNode } from 'react';

export type SrsRating = 'chuaThuoc' | 'daThuoc';

const OPTIONS: { key: SrsRating; label: string }[] = [
  { key: 'chuaThuoc', label: 'Chưa thuộc' },
  { key: 'daThuoc', label: 'Đã thuộc' },
];

const HOUR = 60;
const DAY = 24 * HOUR;

/** 1 chữ số thập phân, bỏ ".0" — "1.5 tháng", "2 năm". */
const oneDecimal = (n: number) => String(Math.round(n * 10) / 10);

export function formatInterval(minutes: number): string {
  if (minutes < HOUR) return `${minutes} phút`;
  if (minutes < DAY) return `${Math.round(minutes / HOUR)} giờ`;
  const days = Math.round(minutes / DAY);
  if (days < 30) return `${days} ngày`;
  if (days < 365) return `${oneDecimal(days / 30)} tháng`;
  return `${oneDecimal(days / 365)} năm`;
}

/**
 * 2 nút tự đánh giá flashcard — dùng chung cho duyệt tự do lẫn SRS (ở SRS: Chưa thuộc = AGAIN,
 * Đã thuộc = GOOD).
 */
export function RatingButtons({
  onRate,
  disabled = false,
  intervalMinutes,
  icons,
}: {
  onRate?: (r: SrsRating) => void;
  disabled?: boolean;
  /** Số phút tới lần ôn kế nếu bấm từng nút — có thì hiện dưới nhãn ("10 phút", "4 ngày"). */
  intervalMinutes?: Record<SrsRating, number>;
  icons?: Partial<Record<SrsRating, ReactNode>>;
}) {
  return (
    <div style={{ display: 'flex', gap: 12, flex: 1 }}>
      {OPTIONS.map((o) => (
        <button
          key={o.key}
          onClick={() => onRate?.(o.key)}
          disabled={disabled}
          style={{
            flex: 1,
            height: 56,
            borderRadius: 999,
            border: 'none',
            background: 'var(--navy-100)',
            color: 'var(--cta-default)',
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.45 : 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
            fontFamily: 'var(--font-vi)',
            fontWeight: 700,
            fontSize: 14,
          }}
        >
          {icons?.[o.key]}
          <span>
            {o.label}
            {intervalMinutes && (
              <span style={{ display: 'block', fontSize: 12, fontWeight: 500, color: 'var(--text-secondary)' }}>
                {formatInterval(intervalMinutes[o.key])}
              </span>
            )}
          </span>
        </button>
      ))}
    </div>
  );
}
